// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"d58881c8","110":"72a538d6","217":"08e2d8e0","374":"67bc9900","452":"17278f56","480":"de522077","780":"9055ae4a","797":"72a538d6","816":"a80a9d74","820":"ab496a05","855":"4b4bfd7c","886":"0bd4545b","968":"d30c9a67","973":"72a538d6","988":"36ddd206"}[chunkId] + ".chunk.css";
};